/* src/app/components/dialogs/select-filter-new/select-filter-new.component.scss */
:host mat-form-field {
  --form-field-error-display: none;
  --font-size: 13px;
  width: 100%;
  height: 48px;
}
:host mat-form-field.density-neg-2 {
  height: 45px;
}
:host .filter-field:has(mat-form-field) {
  margin-top: 10px;
}
tr:has(td mat-form-field, td > td mat-form-field) > td {
  padding-top: 10px;
}
mat-dialog-content {
  margin: 0 0 24px;
  padding: 0;
  min-width: 200px;
  min-height: 50px;
}
lex-field-search {
  --field-search___margin: 12px 0 24px 0;
}
mat-tab-group {
  --mat-tab-body-content___overflow: auto;
  --mat-tab-body-content___display: flex;
  --mat-tab-body-content___flex-direction: column;
}
.list {
  height: 150px;
  overflow: auto;
  border: 1px solid #949494;
  border-radius: 4px;
}
.row {
  display: flex;
  gap: 20px;
  width: 100%;
}
.row.bates mat-form-field {
  width: 124px;
}
.filter-field {
  padding-left: 10px;
}
.filter-field:has(.single-checkbox-field) {
  align-items: center;
}
.filter-field:has(.single-checkbox-field) .single-checkbox-field {
  width: calc(100% - 48px);
}
mat-tab-group {
  --mat-tab-body-content___overflow: hidden;
}
.mat-mdc-select-arrow-wrapper {
  --select-arrow___margin-right: 6px;
}
.op {
  border: grey solid 1.5px;
  border-radius: 4px;
  color: grey;
  width: 20px;
  cursor: pointer;
}
.op:hover {
  background: #e0e0e0;
}
.field {
  font-size: medium;
  width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 5px;
}
:host-context(.dark-theme) .op:hover {
  background-color: #464646;
}
/*# sourceMappingURL=select-filter-new.component.css.map */
